import FBody from '@/plugins/form/FBody';
import FNumber from '@/plugins/form/FNumber';
import FTime from '@/plugins/form/FTime';
import FDictionaryCountry from '@/modules/Dictionary/Country/Select';
import FDictionaryService from '@/modules/Dictionary/Service/Select';
import FDictionaryCity from '@/modules/Dictionary/City/Select';

export default class extends FBody {
  service = new FDictionaryService();

  startDay = new FNumber({
    label: 'Начало день',
  });

  startTime = new FTime({
    label: 'Начало время',
  });

  durationDay = new FNumber({
    label: 'Продол. дней',
  });

  durationHour = new FTime({
    label: 'Продол. время',
  });

  country = new FDictionaryCountry({
    label: 'Страна',
    required: true,
  });

  city = new FDictionaryCity({
    label: 'Город',
    required: true,
  });

  name = '';

  id = 0;


  constructor(props = {}) {
    super(props);
    this.setItems([
      ['startDay', this.startDay],
      ['startTime', this.startTime],
      ['durationDay', this.durationDay],
      ['durationHour', this.durationHour],
      ['country', this.country],
      ['city', this.city],
    ]);
    this.city.country = this.country;
  }

  get dataFlight() {
    if (this.service.value?.value === 1) {
      return {
        FromCountryId: this.country.value?.value || null,
        FromCountryName: this.country.value?.label || '',
        FromCityId: this.city.value?.value || null,
        FromCityName: this.city.value?.label || '',
        ToCountryId: this.countryTo.value?.value || null,
        ToCountryName: this.countryTo.value?.label || '',
        ToCityId: this.cityTo.value?.value || null,
        ToCityName: this.cityTo.value?.label || '',
        FlightId: this.flight.value?.value || null,
        FlightName: this.flight.value?.label || '',
        TariffId: this.tariff.value?.value || null,
        TariffName: this.tariff.value?.value || '',
      };
    }
    return null;
  }

  set dataFlight(data) {
    if (this.service.value?.value === 1) {
      this.country.set({
        value: data.FromCountryId,
        label: data.FromCountryName,
      });
      this.city.set({
        value: data.FromCityId,
        label: data.FromCityName,
      });
      this.countryTo.set({
        value: data.ToCountryId,
        label: data.ToCountryName,
      });
      this.cityTo.set({
        value: data.ToCityId,
        label: data.ToCityName,
      });
      this.flight.set({
        value: data.FlightId,
        label: data.FlightName,
      });
      this.tariff.set({
        value: data.TariffId,
        label: data.TariffName,
      });
    }
  }

  get dataTransfer() {
    if (this.service.value?.value === 2) {
      return {
        TransferId: this.transfer?.value?.value || null,
        TransferName: this.transfer.value?.label || '',
        TransportId: this.transport.value?.value || null,
        TransportName: this.transport.value?.label || '',
      };
    }
    return null;
  }

  set dataTransfer(data) {
    if (this.service.value?.value === 2) {
      this.transfer.set({
        value: data.TransferId,
        label: data.TransferName,
      });
      this.transport.set({
        value: data.TransportId,
        label: data.TransportName,
      });
    }
  }

  get dataHotel() {
    if (this.service.value?.value === 3) {
      return {
        HotelId: this.hotel?.value?.value || null,
        HotelName: this.hotel?.value?.label || '',
        RoomTypeId: this.roomType?.value?.value || null,
        RoomTypeName: this.roomType?.value?.label || '',
        RoomCategoryId: this.roomCategory?.value?.value || null,
        RoomCategoryName: this.roomCategory?.value?.label || '',
        RoomAccommodationId: this.roomAccommodation?.value?.value || null,
        RoomAccommodationName: this.roomAccommodation?.value?.label || '',
        BoardingId: this.boarding?.value?.value || null,
        BoardingName: this.boarding?.value?.label || '',
      };
    }
    return null;
  }

  set dataHotel(data) {
    if (this.service.value?.value === 3) {
      this.hotel.set({
        value: data.HotelId,
        label: data.HotelName,
      });
      this.roomType.set({
        value: data.RoomTypeId,
        label: data.RoomTypeName,
      });
      this.roomCategory.set({
        value: data.RoomCategoryId,
        label: data.RoomCategoryName,
      });
      this.roomAccommodation.set({
        value: data.RoomAccommodationId,
        label: data.RoomAccommodationName,
      });
      this.boarding.set({
        value: data.BoardingId,
        label: data.BoardingName,
      });
    }
  }

  get dataExcursion() {
    if (this.service.value?.value === 4) {
      return {
        ExcursionId: this.excursion?.value?.value || null,
        ExcursionName: this.excursion?.value?.label || '',
        TransportId: this.transport?.value?.value || null,
        TransportName: this.transport?.value?.label || '',
      };
    }
    return null;
  }

  set dataExcursion(data) {
    if (this.service.value?.value === 4) {
      this.excursion.set({
        value: data.ExcursionId,
        label: data.ExcursionName,
      });
      this.transport.set({
        value: data.TransportId,
        label: data.TransportName,
      });
    }
  }

  get dataShip() {
    if (this.service.value?.value === 7) {
      return {
        ShipId: this.ship?.value?.value || null,
        ShipName: this.ship?.value?.label || '',
        CabinId: this.cabin?.value?.value || null,
        CabinName: this.cabin?.value?.label || '',
        BoardingId: this.boarding?.value?.value || null,
        BoardingIdName: this.boarding?.value?.label || '',
        RoomAccommodationId: this.roomAccommodation?.value?.value || null,
        RoomAccommodationName: this.roomAccommodation?.value?.label || '',
      };
    }
    return null;
  }

  set dataShip(data) {
    if (this.service.value?.value === 7) {
      this.ship.set({
        value: data.ShipId,
        label: data.ShipName,
      });
      this.cabin.set({
        value: data.CabinId,
        label: data.CabinName,
      });
      this.boarding.set({
        value: data.BoardingId,
        label: data.BoardingIdName,
      });
      this.roomAccommodation.set({
        value: data.RoomAccommodationId,
        label: data.RoomAccommodationName,
      });
    }
  }

  get dataAdditional() {
    if (([1, 2, 3, 4, 7]).includes(this.service.value?.value)) {
      return null;
    }
    const data = {
      AdditionalServiceId: this.additional?.value?.value || null,
      AdditionalServiceName: this.additional?.value?.label || '',
      AddDescription1Id: this.description1?.value?.value || null,
      AddDescription1Name: this.description1?.value?.label || '',
      AddDescription2Id: this.description2?.value?.value || null,
      AddDescription2Name: this.description2?.value?.label || '',
    };
    if (this.service.value?.value === 9) {
      data.AdditionalServiceId = this.ship?.value?.value || null;
      data.AdditionalServiceName = this.ship?.value?.label || '';
    }
    return data;
  }

  set dataAdditional(data) {
    if (!([1, 2, 3, 4, 7]).includes(this.service.value?.value)) {
      if (this.description1) {
        this.description1.set({
          value: data.AddDescription1Id,
          label: data.AddDescription1Name,
        });
      }
      if (this.description2) {
        this.description2.set({
          value: data.AddDescription2Id,
          label: data.AddDescription2Name,
        });
      }
      if (this.additional) {
        this.additional.set({
          value: data.AdditionalServiceId,
          label: data.AdditionalServiceName,
        });
      }
      if (this.ship) {
        this.ship.set({
          value: data.AdditionalServiceId,
          label: data.AdditionalServiceName,
        });
      }
    }
  }

  get data() {
    const data = super.data;
    return {
      Id: this.id || 0,
      Name: this.name || '',
      Day: data.startDay || 1,
      StartTime: this.startTime.getMilliseconds() || 0,
      Duration: data.durationDay || 0,
      DurationTime: this.durationHour.getMilliseconds() || 0,
      CountryId: this.country?.value?.value || null,
      CountryName: this.country?.value?.label || '',
      RegionId: null,
      CityId: this.city?.value?.value || null,
      CityName: this.city?.value?.label || '',
      PeopleCount: 1,
      ServiceClass: {
        Id: this.service.value?.value,
        Name: this.service.value?.label,
        IsCity: this.service.value?.isCity,
        IsID1: this.service.value?.isID1,
        IsID2: this.service.value?.isID2,
        TariffServicePrices: this.service.value?.servicePrices,
      },
      AirflightData: this.dataFlight,
      TransferData: this.dataTransfer,
      HotelData: this.dataHotel,
      ExcursionData: this.dataExcursion,
      CruiseData: this.dataShip,
      AdditionalData: this.dataAdditional,
      TariffServicePrices: this.servicePrices,
    };
  }

  set data(data) {
    this.id = data.Id || 0;
    this.name = data.Name || '';
    this.startDay.set(data.Day || 0);
    this.startTime.setMilliseconds(data.StartTime || 0);
    this.durationDay.set(data.Duration || 0);
    this.durationHour.setMilliseconds(data.DurationTime || 0);
    this.country.set({
      value: data.CountryId,
      label: data.CountryName,
    });
    this.city.set({
      value: data.CityId,
      label: data.CityName,
    });
    this.service.set({
      value: data.ServiceClass.Id,
      label: data.ServiceClass.Name,
      isCity: data.ServiceClass.IsCity,
      isID1: data.ServiceClass.IsID1,
      isID2: data.ServiceClass.IsID2,
      servicePrices: this.service.value?.TariffServicePrices ?? [],
    });
    this.dataFlight = data.AirflightData;
    this.dataTransfer = data.TransferData;
    this.dataHotel = data.HotelData;
    this.dataExcursion = data.ExcursionData;
    this.dataShip = data.CruiseData;
    this.dataAdditional = data.AdditionalData;
    this.servicePrices = data.TariffServicePrices;
  }

  set(value = {}) {
    this.__set('startDay', value.startDay, 1);
    this.__set('startTime', value.startTime, '');
    this.__set('durationDay', value.durationDay, 0);
    this.__set('durationHour', value.durationHour, '');
    this.__set('country', value.country, null);
    this.__set('city', value.city, null);
    return this;
  }

  toString() {
    return '';
  }
}
